import { Component, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { HistoricalDataService } from '../../services/historical-data/historical-data.service';
import { AppointmentStatusEnum, CVA_CONSTANTS, IHistoricalData, IPatientDemography, VIEW_MODE, allergiesColumns, immunizationColumns, medicationColumns } from '../../util/constants';
import { PatientService } from '../../services/patient/patient.service';
import { PatientResponse, StartConsulationPatient } from '../../models/patient.interface';
import { Labhistory } from '../../models/labhistory';
import { ActionClick, GridColumn } from '../../models/data-table.interface';
import { AllergyResponse } from '../../models/allergy.interface';
import { DatePipe } from '@angular/common';
import { SoapNote, sectionName } from '../../models/dictation.interface';
import { PageEvent } from '@angular/material/paginator';
import DOMPurify from 'dompurify';
import { DomSanitizer } from '@angular/platform-browser';
import { convertRtfToHtml, mergeVitalTableData, processVitalSignsResponse } from '../../util/utils';
import { VitalSigns } from '../../models/vital-signs.interface';
import { MatTabChangeEvent, MatTabGroup } from '@angular/material/tabs';
import { MedicationRequest } from '../../models/medical-request.interfcae';
import { Immunization } from '../../models/immunization.interface';
import { PractitionerService } from '../../services/practitioner/practitioner.service';
import { AppointmentResponse, IAppointment, IAppointmentPatient, IPatient } from '../../models/appointment.interface';
import { Router } from '@angular/router';
import { ROUTE_CONSTANTS } from '../../util/route.constants';
import { MatDialogRef } from '@angular/material/dialog';
import { SoapServiceService } from '../../services/soap-service/soap-service.service';
import { SidenavService } from '../../services/sidenav/sidenav.service';
import { CVANotificationService } from '../../services/cva-notification/cva-notification.service';
import { NotificationClassEnum } from '../../models/notification-class.enum';
import { ConfirmationDialogService } from '../../shared/confirmation-dialog/services/confirmation-dialog.service';
import { AppointmentService } from '../../services/appointment/appointment.service';
import moment, { Moment } from 'moment';
import { TimeDifferencePipe } from '../../shared/pipes/time-difference.pipe';
import { HttpErrorResponse } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { PractitionerResponse } from '../../models/practitioner.interface';
import { firstValueFrom } from 'rxjs';
import { CVA_AUTH_MODULES } from '../../models/auth.modules.enum';
import { TasksService } from '../../services/tasks/tasks.service';
import { ClinicalRecordsService, ClinicalRecordTab } from '../../services/clinical-tabs/clinical-records.service';

@Component({
  standalone: false,
  selector: 'cva-patient-search-modal',
  templateUrl: './patient-search-modal.component.html',
  styleUrl: './patient-search-modal.component.scss',

})
export class PatientSearchModalComponent {
  CVA_AUTH_MODULES = CVA_AUTH_MODULES;
  CVA_CONSTANTS = CVA_CONSTANTS;
  historicalDataForAll: IHistoricalData = {} as IHistoricalData;
  patientId: string = '';
  loading: boolean = true;
  showPagination: boolean = false;
  stickyColumnPosition: number = -1;
  errorMsg = false;
  pageSize = 5;
  labdata: Labhistory[] = [];
  validPatient: IPatient;
  labDataArray: { date: string; entries: { displayName: string; resultData: HTMLElement[][]; }[]; }[] | undefined | null;

  columns: GridColumn<Record<string, string>>[] = [];
  allergiesColumns = allergiesColumns;
  allergiesData: Record<string, string>[] = [];
  vitalData: Record<string, string>[] = [];
  vitalsColumns: GridColumn<Record<string, string>>[] = [];
  consultationHistoryCurPage: SoapNote[] = [];
  consultationHistory: SoapNote[] = [];
  consultationHistoryPageSize = 5;
  consultationHistoryPageIndex = 0;

  labResults: { date: string; entries: { displayName: string; resultData: HTMLElement[][]; }[]; }[] = [];
  labResultsPage: { date: string; entries: { displayName: string; resultData: HTMLElement[][]; }[]; }[] = [];
  labResultsPageIndex = 0;
  labResultsPageSize = 5;
  patientDemography: IPatientDemography = {} as IPatientDemography;
  medicalRequestData: { date: string, table: { medication: string, duration: string, qty: string, route: string, instruction: string }[] }[] = [];

  medicalRequestCurPage: { date: string, table: { medication: string, duration: string, qty: string, route: string, instruction: string }[] }[] = [];
  medicationColumns = medicationColumns;
  medicationRequestPageIndex = 0;
  medicationRequestPageSize = 5;

  immunizationsData: Record<string, string>[] = [];
  immunizationColumns = immunizationColumns;
  showClinicalData = false;
  showAppointmentData = false;
  appointments: IAppointment[] = []
  start: Moment = moment().startOf('day');
  end: Moment = moment().endOf('day');
  displayedColumns: GridColumn<IAppointment>[] = [
    { field: "time", label: "Time", tdClass: "apt-time" },
    { field: "appointmentType", label: "Visit Type", tdClass: "normal-text" },
    { field: "notes", label: "Reason", width: "25%", tdClass: "notes-field normal-text text-break", hasLargeText: true },
    { field: "status", label: "Status", tdClass: "status-field normal-text" },
    { field: "duration", label: "Duration", tdClass: "normal-text" },
    {
      field: "hasTranscription",
      label: "Transcription",
      tdClass: "normal-text",
      eventType: 'transcription',
      icon: environment.cvaUI_url + "/assets/icons/notes.svg",
      disabledIcon: environment.cvaUI_url + "/assets/icons/notes-disabled.svg",
      readOnlyIcon: environment.cvaUI_url + "/assets/icons/notes-readonly.svg"
    },
  ];

  ClinicalRecordTab = ClinicalRecordTab;

  @ViewChildren(MatTabGroup) tabGroups!: QueryList<MatTabGroup>;
  @ViewChild('tabGroup') tabGroupVar!: MatTabGroup;
  constructor(
    private readonly historicalDataService: HistoricalDataService,
    private readonly patientService: PatientService,
    private readonly datePipe: DatePipe,
    private readonly sanitizer: DomSanitizer,
    private readonly practitionerService: PractitionerService,
    private readonly router: Router,
    private readonly soapServiceService: SoapServiceService,
    private readonly sideNavService: SidenavService,
    public dialogRef: MatDialogRef<PatientSearchModalComponent>,
    private readonly cvaNotificationService: CVANotificationService,
    private readonly confirmationDialogService: ConfirmationDialogService,
    private readonly appointmentService: AppointmentService,
    private readonly timeDifferencePipe: TimeDifferencePipe,
    private readonly tasksService: TasksService,
    private readonly clinicalRecordsService: ClinicalRecordsService,
  ) {
  }

  onTabChanged(event: MatTabChangeEvent) {
    switch (event.index) {
      case 0:
        this.tabGroups.forEach((tabGroup) => {
          tabGroup._tabHeader._nextPaginator.nativeElement.ariaHidden = "false";
          tabGroup._tabHeader._previousPaginator.nativeElement.ariaHidden = "false";
        });
        this.setSoapNoteRecords(this.historicalDataForAll.consultation);
        break;
      case 1:
        this.stickyColumnPosition = 0;
        this.setVitalRecords(this.historicalDataForAll.vitals);
        break;
      case 2:
        this.setAllergyRecords(this.historicalDataForAll.allergies);
        break;
      case 3:
        this.getLabOrderHistoryData(this.historicalDataForAll.labResult);
        break;
      case 4:
        this.getMedicalRequestData();
        break;
      case 5:
        this.setImmunization(this.historicalDataForAll.immunization);
        this.showPagination = true;
        break;

    }
  }
  async getLabOrderHistoryData(val: Labhistory[]) {
    this.labdata = val;
    this.labDataArray = await this.getMappedDataWithHtml();
    this.setLabResultsPageEntries();
  }

  searchPatientById(patientId: HTMLInputElement): void {
    const medicalRecordNumber = patientId.value?.trim();
    this.errorMsg = false;
    this.showClinicalData = false;
    this.patientService.getPatientById(medicalRecordNumber).subscribe({
      next: (result: { response: PatientResponse }) => {
        if (result.response?.dateOfBirth) {
          this.showAppointmentData = false;
          this.validPatient = result.response;
          const demographics = result.response
          const name = demographics.firstName + ' ' + demographics.lastName;
          const { dateOfBirth, gender } = demographics
          this.patientDemography = {
            name, dateOfBirth, gender
          };

        } else {
          this.invalidPatientId();
        }
      },
      error: () => {
        this.invalidPatientId();
      }
    });
  }

  invalidPatientId() {
    this.errorMsg = true;
    this.patientDemography = {} as IPatientDemography;
  }

  getHistoricalData(referenceId: string, startDate: string, endDate: string) {
    this.historicalDataService
      .getHistoricalDataForAll$(referenceId, startDate, endDate)
      .subscribe({
        next: (data: IHistoricalData) => {
          this.showClinicalData = true;
          this.historicalDataForAll = data;
          if (this.tabGroupVar) {
            this.tabGroupVar.selectedIndex = 0;
          }
          setTimeout(() => this.onTabChanged({ index: 0 } as MatTabChangeEvent));
        },
        error: (err) => (console.log(err))
      });
  }

  setAllergyRecords(allergies: AllergyResponse[]) {
    this.allergiesData = allergies.map((allergy) => {
      return {
        onsetDate: allergy.onsetDate
          ? (this.datePipe.transform(allergy.onsetDate, 'd MMM, y') as string)
          : '-',
        clinicalStatus:
          allergy.clinicalStatus?.code
            ? allergy.clinicalStatus.code
            : '-',
        verificationStatus:
          allergy.verificationStatus?.code
            ? allergy.verificationStatus.code
            : '-',
        criticality: allergy.criticality ? allergy.criticality : '-',
        category: allergy.category ? allergy.category : '-',
        type: allergy.type?.code ? allergy.type.code : '-',
        allergen:
          allergy.allergen?.display
            ? allergy.allergen.display
            : '-',
        recordedDate: allergy.recordedDate
          ? (this.datePipe.transform(
            allergy.recordedDate,
            'd MMM, y'
          ) as string)
          : '-',
      };
    });
  }

  async setSoapNoteRecords(historical: SoapNote[], isNewData = false) {
    try {
      this.loading = false;
      const content = historical.map(async (history: SoapNote) => {
        for (const property in history) {
          if (
            sectionName.assessment == property ||
            sectionName.subjective == property ||
            sectionName.objective == property ||
            sectionName.plan == property
          ) {
            if (history[property] && typeof history[property] === 'string') {
              if (history[property].toString().length > 0 && history[property].toString().startsWith('{\\rtf')) {
                const htmlElements = await convertRtfToHtml(history[property] as string); //NOSONAR
                history[property] = this.getSafeHTML(htmlElements)
              }
            }
          }
        }
        return history;
      });
      const consultationHistory = await Promise.all(content);
      consultationHistory.sort((a, b) => {
        const aDate = new Date(a.soapNoteDate);
        const bDate = new Date(b.soapNoteDate);
        if (aDate < bDate) {
          return 1;
        } else if (aDate > bDate) {
          return -1;
        }
        return 0;
      });

      if (isNewData) {
        this.consultationHistory.push(...consultationHistory);
      } else {
        this.consultationHistory = consultationHistory;
      }

      this.setConsultationHistoryPageEntries();
      this.setConsultationHistoryPageEntries();
      this.updateViewMoreVisibility(
        this.consultationHistory.length,
        this.consultationHistoryPageSize,
        this.consultationHistoryPageIndex,
        ClinicalRecordTab.ConsultationSummary
      );
    } catch (error) {
      console.error(error);
    }
  }

  handleConsultationHistoryPageEvent(pageEvent: PageEvent) {
    this.consultationHistoryPageIndex = pageEvent.pageIndex;
    this.consultationHistoryPageSize = pageEvent.pageSize;
    this.setConsultationHistoryPageEntries();
    this.updateViewMoreVisibility(
      this.consultationHistory.length,
      this.consultationHistoryPageSize,
      this.consultationHistoryPageIndex,
      ClinicalRecordTab.ConsultationSummary
    );
  }

  updateViewMoreVisibility(
    totalLength: number,
    pageSize: number,
    pageIndex: number,
    tab: ClinicalRecordTab
  ) {
    const totalPages = Math.ceil(totalLength / pageSize);
    const isLastPage = (pageIndex + 1) === totalPages;
    this.clinicalRecordsService.setViewMoreVisibility(
      tab,
      isLastPage && this.clinicalRecordsService.shouldShowHasData(tab)
    );

  }

  setConsultationHistoryPageEntries() {
    const startIndex =
      this.consultationHistoryPageIndex * this.consultationHistoryPageSize;
    const endIndex = startIndex + this.consultationHistoryPageSize;
    this.consultationHistoryCurPage = this.consultationHistory.slice(
      startIndex,
      endIndex
    );
  }

  setVitalRecords(vitalSigns: VitalSigns[], isNewData = false) {
    const records = processVitalSignsResponse(
      vitalSigns,
      (sortedDates: string[]) => {
        if (this.vitalsColumns.length === 0) {
          this.vitalsColumns.push({
            field: 'displayName',
            label: 'Parameters',
            width: "20px"
          });
        }

        const existingFields = new Set(this.vitalsColumns.map(col => col.field));

        const uniqueDates = Array.from(new Set(sortedDates));

        const newColumns = uniqueDates
          .filter(date => !existingFields.has(date))
          .map(date => ({
            field: date,
            label: this.datePipe.transform(date, 'd MMM, yyyy') ?? '',
            width: "20px",
            isVital: true
          }));

        // Add new columns to the existing ones       
        this.vitalsColumns = [
          ...this.vitalsColumns,
          ...newColumns,
        ];
      }
    );

    if (isNewData) {
      this.vitalData = mergeVitalTableData(this.vitalData, records);
    } else {
      this.vitalData = records;
    }

  }

  async getMappedDataWithHtml() {
    const dataMap = this.mapDataByDate();
    const resultArray: { date: string; entries: { displayName: string; resultData: string[] }[] }[] = [];

    for (const [date, dateMap] of dataMap.entries()) {
      const entries: { displayName: string; resultData: string[] }[] = [];
      for (const [, resultData] of dateMap.entries()) {
        entries.push({
          displayName: String(resultData.displayName),
          resultData: Array.isArray(resultData.resultData) ? resultData.resultData : []
        });
      }

      resultArray.push({
        date,
        entries
      });
    }

    // Convert RTF to HTML for each resultData
    const htmlResults = await Promise.all(
      resultArray.map(async (dateEntry) => {
        return {
          date: dateEntry.date,
          entries: await Promise.all(
            dateEntry.entries.map(async (entry) => {
              return {
                displayName: entry.displayName,
                resultData: await Promise.all(entry.resultData.map(rtf => convertRtfToHtml(rtf)))
              };
            })
          )
        };
      })
    );

    return htmlResults;
  }
  private mapDataByDate() {
    const map = new Map<string, Map<string, string[]>>();

    for (const item of this.labdata) {
      const date = new Date(item.issuedOn);
      const formattedDate = this.datePipe.transform(date, 'dd/MM/yyyy') ?? '';

      if (!map.has(formattedDate)) {
        map.set(formattedDate, new Map<string, string[]>());
      }

      const dateMap = map.get(formattedDate)!;

      if (!dateMap.has(item.displayName)) {
        dateMap.set(item.displayName, []);
      }

      dateMap.get(item.displayName)!.push(item.resultData);
    }

    const formattedResult = new Map<string, Array<{ displayName: string, resultData: string[] }>>();

    for (const [date, dateMap] of map.entries()) {
      const dateEntries: Array<{ displayName: string, resultData: string[] }> = [];
      for (const [displayName, resultData] of dateMap.entries()) {
        dateEntries.push({ displayName, resultData });
      }
      formattedResult.set(date, dateEntries);
    }

    return formattedResult;
  }

  handleLabResultsPageEvent(pageEvent: PageEvent) {
    this.labResultsPageIndex = pageEvent.pageIndex;
    this.labResultsPageSize = pageEvent.pageSize;
    this.setLabResultsPageEntries();
  }

  setLabResultsPageEntries() {
    const startIndex =
      this.labResultsPageIndex * this.labResultsPageSize;
    const endIndex = startIndex + this.labResultsPageSize;

    if (this.labDataArray) {
      this.labResultsPage = this.labDataArray.slice(
        startIndex,
        endIndex
      );
    }
  }
  getSafeHTML(htmlElements: HTMLElement[]) {
    if (htmlElements) {
      const div = document.createElement('div');
      div.append(...htmlElements);
      //sanitizing to remove unsafe elements
      const sanitizedDOM = DOMPurify.sanitize(div.innerHTML);
      return this.sanitizer.bypassSecurityTrustHtml(sanitizedDOM);  //NOSONAR
    }
    return '';
  }

  //Medication methods
  public getMedicalRequestData() {
    this.columns = [
      {
        field: 'medication',
        label: 'Medication'
      },
      {
        field: 'duration',
        label: 'Duration',
      },
      {
        field: 'qty',
        label: 'Quantity',
      },
      {
        field: 'route',
        label: 'Route',
      },
      {
        field: 'instruction',
        label: 'Instruction',
      },
    ];

    this.medicalRequestData = this.mapMedicalRequestData(this.historicalDataForAll.medication);
    this.setMedicalPageEntries()
    this.updateViewMoreVisibility(
      this.medicalRequestData.length,
      this.medicationRequestPageSize,
      this.medicationRequestPageIndex,
      ClinicalRecordTab.MedicationRequest
    );
  }

  public mapMedicalRequestData(medicalData: MedicationRequest[]) {
    const map = new Map<string, {
      medication: string,
      duration: string,
      qty: string,
      route: string,
      instruction: string
    }[]>();
    medicalData.forEach((item) => {
      const date = new Date(item.authoredOn).toISOString().split('T')[0]; // Get the date part only
      const table = item.dosageInstructions.map((instruction) => ({
        medication: item.medicationText,
        duration: item.dispenseRequest?.expectedSupplyDuration
          ? `${item.dispenseRequest.expectedSupplyDuration?.value} ${item.dispenseRequest.expectedSupplyDuration.unit}`
          : "-",
        qty: item.dispenseRequest.quantity.value.toString(),
        route: instruction.routeText,
        instruction: instruction.timingText ?? "-"
      }));
      if (map.has(date)) {
        map.get(date)?.push(...table);
      } else {
        map.set(date, table);
      }
    });
    // Convert the map to an array for further processing or rendering
    const medicalRequestData = Array.from(map.entries()).map(([date, table]) => ({
      date,
      table
    }));

    medicalRequestData.sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime());

    return medicalRequestData;
  }

  handleMedicationRequestPageEvent(pageEvent: PageEvent) {
    this.medicationRequestPageIndex = pageEvent.pageIndex;
    this.medicationRequestPageSize = pageEvent.pageSize;
    this.setMedicalPageEntries();
    this.updateViewMoreVisibility(
      this.medicalRequestData.length,
      this.medicationRequestPageSize,
      this.medicationRequestPageIndex,
      ClinicalRecordTab.MedicationRequest
    );
  }

  setMedicalPageEntries() {
    const startIndex =
      this.medicationRequestPageIndex * this.medicationRequestPageSize;
    const endIndex = startIndex + this.medicationRequestPageSize;

    this.medicalRequestCurPage = this.medicalRequestData.slice(
      startIndex,
      endIndex
    );

  }

  setImmunization(immunizations: Immunization[]) {
    this.immunizationsData = immunizations.map((immunization) => {
      return {
        "uid": immunization.uid,
        "expirationDate": immunization.expirationDate ? this.datePipe.transform(immunization.expirationDate, 'd MMM, y') as string : '-',
        "note": immunization.note ?? '-',
        "status": immunization.status,
        "displayName": immunization.vaccineName ?? '-',
        "patientId": immunization.patientId,
        "patientName": immunization.patientName,
        "occurrenceDate": immunization.occurrenceDateTime ? this.datePipe.transform(immunization.occurrenceDateTime, 'd MMM, y') as string : '-',
        "practitionerId": immunization.practitionerId,
        "practitionerName": immunization.practitionerName
      }
    })
  }

  filterAppointment(appointments: IAppointment[]) {
    return appointments.sort((a, b) => a.start.localeCompare(b.start));
  }

  setAppointmentRecords(records: AppointmentResponse[]) {
    const appointments: IAppointment[] = records.map((appointment) => {
      return {
        ...appointment,
        time: this.datePipe.transform(appointment.start, 'd MMM, y HH:mm') ?? '',
        name: `${appointment.practitioner?.firstName} ${appointment.practitioner?.lastName}`,
        duration: this.timeDifferencePipe.transform(appointment.start, appointment.end),
        isDeleted: appointment.status === AppointmentStatusEnum.CANCELLED,
        hasTranscription: (appointment.transcription && appointment.transcription.length > 0) || false,
        doNotshowDeleteBtn: true
      };
    });
    return this.filterAppointment(appointments);
  }


  getAppointments() {
    const providerId = localStorage.getItem('providerId');
    if (providerId && this.validPatient) {
      this.practitionerService.getPractitionerByHpiId(providerId)
        .subscribe((practitioner) => {
          this.appointmentService.getAllAppointmentsForPatient(
            this.validPatient.uid,
            practitioner.uid,
            this.start.toDate(),
            this.end.toDate(),
          ).subscribe({
            next: (res: { response: AppointmentResponse[] }) => {
              this.appointments = this.setAppointmentRecords(res.response);
              if (this.appointments.length) {
                this.showAppointmentData = true;
                this.showClinicalData = false;
              } else {
                this.startNewConsultation();
              }
            },
            error: (errorResponse: HttpErrorResponse) => {
              let errorMessage: string = '';
              if (errorResponse.error?.error) {
                errorMessage = errorResponse.error.error.errorMessage;
              }
              this.cvaNotificationService.showNotification(
                errorMessage || CVA_CONSTANTS.MESSAGE.NO_APPOINTMENT,
                NotificationClassEnum.ERROR
              );
              console.error(errorMessage)
            }
          });
        })
    } else {
      console.error(providerId, this.validPatient)
      this.cvaNotificationService.showNotification(
        CVA_CONSTANTS.MESSAGE.GENERATE_SOAP_NOTE_ERR,
        NotificationClassEnum.ERROR
      );
    }
  }

  checkIfExistingConsulationisDone(obj: IAppointmentPatient, practitioner: PractitionerResponse) {
    if (obj?.consultationDone) {
      this.confirmationDialogService.openConfirmDialog(CVA_CONSTANTS.MESSAGE.CONSULTATION_ALREADY_DONE)
        .subscribe((confirmed) => {
          if (confirmed) {
            this.setPatientInfoAndNavigate(obj, practitioner, VIEW_MODE.TAB)
          }
        })
    } else {
      this.setPatientInfoAndNavigate(obj, practitioner, VIEW_MODE.TAB)
    }
  }

  async checkIfExistingConsultionGoing(): Promise<boolean> {
    if (this.router.url === ('/' + ROUTE_CONSTANTS.CONSULTATION)) {
      const patientId = localStorage.getItem("patientId");
      let msg = CVA_CONSTANTS.MESSAGE.EXISTING_CONSULTATION;

      if (this.validPatient.uid === patientId) {
        msg = CVA_CONSTANTS.MESSAGE.EXISTING_SAME_CONSULTATION;
      }

      const confirmed = await firstValueFrom(this.confirmationDialogService.openConfirmDialog(msg));
      return confirmed === true;
    } else {
      return true;
    }
  }

  async openExistingConsultation($event: { rowData: IAppointment }) {
    const providerId = localStorage.getItem('providerId');
    if (providerId) {
      const result = await this.checkIfExistingConsultionGoing();
      if (result) {
        this.practitionerService.getPractitionerByHpiId(providerId).subscribe((practitioner) => {
          const obj = { ...$event.rowData, patient: this.validPatient, practitioner: practitioner, isFromPatientSearch: true }
          this.checkIfExistingConsulationisDone(obj, practitioner);
        })
      }
    } else {
      console.error(providerId, this.validPatient)
      this.cvaNotificationService.showNotification(
        CVA_CONSTANTS.MESSAGE.GENERATE_SOAP_NOTE_ERR,
        NotificationClassEnum.ERROR
      );
    }
  }

  async startNewConsultation() {
    const facilityCode = localStorage.getItem('facilityCode');
    const providerId = localStorage.getItem('providerId');
    if (facilityCode && providerId && this.validPatient) {
      const result = await this.checkIfExistingConsultionGoing();
      if (result) {
        this.practitionerService.getPractitionerByHpiId(providerId)
          .subscribe((practitioner) => {
            const obj: StartConsulationPatient = {
              facilityCode: facilityCode,
              providerId: practitioner.uid,
              patientId: this.validPatient.uid
            }
            this.appointmentService.createAppointmentForPatient(obj).subscribe({
              next: (result: { response: IAppointment }) => {
                const obj = { ...result.response, patient: this.validPatient, practitioner: practitioner, isFromPatientSearch: true }
                this.checkIfExistingConsulationisDone(obj, practitioner);
              },
              error: (e) => {
                console.error(e)
              }
            });
          })
      }
    } else {
      console.error(facilityCode, providerId, this.validPatient)
      this.cvaNotificationService.showNotification(
        CVA_CONSTANTS.MESSAGE.GENERATE_SOAP_NOTE_ERR,
        NotificationClassEnum.ERROR
      );
    }
  }

  deleteTabs() {
    localStorage.removeItem("tabs");
    localStorage.removeItem("consultationForm");
    localStorage.removeItem("disableAllApproves");
    this.tasksService.clearAll();
  }

  setPatient(appointment: IAppointment) {
    this.closePopUp();
    this.sideNavService.patientId$ = appointment.patient.referenceId;
    this.sideNavService.patientMRN$ = appointment.patient.medicalRecordNumber;
  }

  closePopUp() {
    this.dialogRef.close(true);
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  navigateToConsulation(appointment: IAppointment, practitioner: any, viewMode = VIEW_MODE.TAB) {
    this.router.navigate([ROUTE_CONSTANTS.CONSULTATION], {
      state: { appointment, viewMode, practitioner: practitioner }
    });
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  navigateToConsulationReload(appointment: IAppointment, practitioner: any, viewMode = VIEW_MODE.TAB) {
    this.router.navigate([ROUTE_CONSTANTS.SOAP_CONFIGURATION]).then(() => {
      this.router.navigate([ROUTE_CONSTANTS.CONSULTATION], {
        state: { appointment, viewMode, practitioner: practitioner, reaload: true }
      });
    });
  }

  // eslint-disable-next-line  @typescript-eslint/no-explicit-any
  setPatientInfoAndNavigate(appointment: IAppointment, practitioner: any, viewMode = VIEW_MODE.TAB) {
    if (this.router.url === ('/' + ROUTE_CONSTANTS.CONSULTATION)) {
      const selectedAppointment = this.soapServiceService.getAppointmentAndDraftedNotes();
      if (!selectedAppointment) {
        this.soapServiceService.setAppointmentAndDraftedNotes(appointment.uid, {}, appointment.transcription);
      }
      this.deleteTabs();
      this.setPatient(appointment);
      this.navigateToConsulationReload(appointment, practitioner, viewMode)
    } else {
      const selectedAppointment = this.soapServiceService.getAppointmentAndDraftedNotes();
      if (selectedAppointment) {
        if (appointment.referenceId !== selectedAppointment?.referenceId) {
          localStorage.removeItem("selectedAppointment");
          this.deleteTabs();
        }
      } else {
        this.soapServiceService.setAppointmentAndDraftedNotes(appointment.uid, {}, appointment.transcription);
        this.deleteTabs()
      }
      this.setPatient(appointment);
      this.navigateToConsulation(appointment, practitioner, viewMode)
    }
  }

  getclinicalRecord() {
    this.showAppointmentData = false;
    this.reset();
    this.clinicalRecordsService.initTab(ClinicalRecordTab.ConsultationSummary);
    this.clinicalRecordsService.initTab(ClinicalRecordTab.Observations);
    this.clinicalRecordsService.initTab(ClinicalRecordTab.MedicationRequest);
    const { startDate, endDate } = this.clinicalRecordsService
      .getDateRange(ClinicalRecordTab.ConsultationSummary);

    this.getHistoricalData(
      this.validPatient?.referenceId,
      startDate,
      endDate
    );
  }

  shouldShowViewMore(tab: ClinicalRecordTab): boolean {
    return this.clinicalRecordsService.shouldShowViewMore(tab);
  }

  getMedicalSummaryData() {
    const { startDate, endDate } = this.clinicalRecordsService.getNextRange(ClinicalRecordTab.ConsultationSummary);

    this.loading = true;
    this.historicalDataService
      .getPreviousConsultationByPatientId$(this.validPatient.referenceId, startDate, endDate)
      .subscribe({
        next: (historical: SoapNote[]) => {
          this.clinicalRecordsService.setHasData(
            ClinicalRecordTab.ConsultationSummary,
            historical.length !== 0
          );
          this.setSoapNoteRecords(JSON.parse(JSON.stringify(historical)), true);
          this.historicalDataForAll.consultation.push(...JSON.parse(JSON.stringify(historical)))
        },
        error: () => (this.loading = false)
      });
  }

  getMedicationRequestData() {
    const { startDate, endDate } = this.clinicalRecordsService
      .getNextRange(ClinicalRecordTab.MedicationRequest);

    this.historicalDataService
      .getMedicationsForPatient$(this.validPatient.referenceId, startDate, endDate)
      .subscribe({
        next: (medicaldata: MedicationRequest[]) => {
          this.clinicalRecordsService.setHasData(
            ClinicalRecordTab.MedicationRequest,
            medicaldata.length !== 0
          );

          this.medicalRequestData.push(
            ...this.mapMedicalRequestData(JSON.parse(JSON.stringify(medicaldata)))
          );

          this.loading = false;
          this.setMedicalPageEntries()
          this.updateViewMoreVisibility(
            this.medicalRequestData.length,
            this.medicationRequestPageSize,
            this.medicationRequestPageIndex,
            ClinicalRecordTab.MedicationRequest
          );

          this.historicalDataForAll.medication.push(...JSON.parse(JSON.stringify(medicaldata)))
        },
        error: () => (this.loading = false),
      });
  }

  getVitalSignsData() {
    const { startDate, endDate } = this.clinicalRecordsService
      .getNextRange(ClinicalRecordTab.Observations);

    this.loading = true;
    this.historicalDataService
      .getVitalSignsForPatient$(this.validPatient.referenceId, startDate, endDate)
      .subscribe({
        next: (vitalSigns: VitalSigns[]) => {
          this.clinicalRecordsService.setViewMoreVisibility(
            ClinicalRecordTab.Observations,
            vitalSigns.length !== 0
          );
          this.setVitalRecords(JSON.parse(JSON.stringify(vitalSigns)), true);
          this.loading = false;

          this.historicalDataForAll.vitals.push(...JSON.parse(JSON.stringify(vitalSigns)))
        },
        error: () => (this.loading = false),
      });
  }

  onActionClick(record: ActionClick<IAppointment>) {
    if (record.action === 'transcription') {
      if (record.rowData.hasTranscription && !record.rowData.pastAppointment) {
        this.openExistingConsultation(record)
      }
    }
  }

  reset() {
    this.medicalRequestData = [];
    this.medicalRequestCurPage = [];
    this.consultationHistory = [];
    this.consultationHistoryCurPage = [];
    this.vitalsColumns = [];
    this.vitalData = [];

    this.medicationRequestPageIndex = 0
    this.consultationHistoryPageIndex = 0;

    this.clinicalRecordsService.resetAllTabStates();
  }
}
